// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { ClientProfileBasicFragment } from '../../../../clientProfiles/graphql/ClientProfile.generated';
import { gql } from '@apollo/client';
import { ClientProfileBasicFragmentDoc } from '../../../../clientProfiles/graphql/ClientProfile.generated';
export type TrusteeDropdown_HouseholdFragment = { __typename?: 'Household', id: string, clientProfiles?: Array<(
    { __typename?: 'ClientProfile' }
    & ClientProfileBasicFragment
  )> | null, clientOrganizations?: Array<{ __typename?: 'ClientOrganization', id: string, name: string }> | null };

export const Operations = {
  Fragment: {
    TrusteeDropdown_Household: 'TrusteeDropdown_Household' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const TrusteeDropdown_HouseholdFragmentDoc = gql`
    fragment TrusteeDropdown_Household on Household {
  id
  clientProfiles {
    ...ClientProfileBasic
  }
  clientOrganizations {
    id
    name
  }
}
    ${ClientProfileBasicFragmentDoc}`;